<template>
  <v-app-bar
      id="default-app-bar"
      height="64"
      app
      flat
      color="primary"
  >
    <default-logo/>
    <v-spacer/>
    <default-account/>
  </v-app-bar>
</template>

<script>
export default {
  name: "DefaultAppBar",
  components: {
    DefaultLogo: () => import(
        './widgets/Logo'
        ),
    DefaultAccount: () => import(
        './widgets/Account'
        )
  }
}
</script>

<style scoped lang="scss">
#default-app-bar {
  z-index: 8;
}
</style>
